import { render, staticRenderFns } from "./TopicsWork.vue?vue&type=template&id=c735668a&scoped=true&"
import script from "./TopicsWork.vue?vue&type=script&lang=ts&"
export * from "./TopicsWork.vue?vue&type=script&lang=ts&"
import style0 from "./TopicsWork.vue?vue&type=style&index=0&id=c735668a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c735668a",
  null
  
)

component.options.__file = "TopicsWork.vue"
export default component.exports